const theme = {
    colors: {
        purple: '#8758ff',
        purple2: '#c5aeff',
        white: '#ffffff',
        gray: '#ffffff4d',
        yellow: '#FFE800',
        brown: '#404040',
        bgColorForm: '#1A1A40'
    },
    angles: {
        angle: '8px',
        angleO: '4px'
    }
}

export default theme;